module.exports = __webpack_public_path__ + "static/img/salad_1.0e266ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/salad_1.png
// module id = ARjB
// module chunks = 0